import React from 'react'
import { store } from './store/store'
import { Provider, useSelector } from 'react-redux'

const Main = (props: any) => {
  return <Provider store={store}>{props.children}</Provider>
}

export default Main
